import ResultsGridItemWithState from "../../../js/external_datasets/search/ResultsGridItem";

export default ResultsGridItemWithState;
